<template>
  <div
    class="well-cell"
    v-if="value != null" :title="get_title()">

    <div :style="get_swatchStyle(value)">
    </div>
    <!--
    свойство value приходит из метода update_plate компонента планшеты
    -->
    <span v-if="value.sample">{{value.sample.name}}</span>
    <span v-else>.</span>

  </div>

  <div v-else>

  </div>

</template>

<script>

	import format from 'string-format'

	import {Plate} from '../../models/Plate'

	export default {
		name: 'plate-96-cell-renderer',
		data: function () {
			return {
				// plate: null,

				// We'll need to define properties in our data object,
				// corresponding to all of the data being injected from
				// the BaseEditorComponent class, which are:
				// - hotInstance (instance of Handsontable)
				// - row (row index)
				// - col (column index)
				// - prop (column property name)
				// - TD (the HTML cell element)
				// - cellProperties (the cellProperties object for the edited cell)
				hotInstance: null,
				TD: null,
				row: null,
				col: null,
				prop: null,
				value: null,
				cellProperties: null
			}
		},

		props: {
			// plate: {type: Object, default: () => null},
		},

		computed: {},

		methods: {
			get_title: function () {
				format((
					"Sample: {sample}\n" +
					"Probes: \n{probes}"),
					{
						sample: this.value.sample,
						probes: this.value.probes, // Array.from(this.value.probes, (p) => format("  {p}", p)).join('\n')
					})
			},

			get_swatchStyle: function () {
				console.debug(format(
					"Plate96CellRenderer.get_swatchStyle() color: '{color}'.",
					{color: this.value.color,}))

				return {
					backgroundColor: this.value.color,
					// position: 'absolute',
					cursor: 'default',
					// left: '1px', top: 0,
					height: '4px',
					width: '100%',
					borderRadius: '15%',
				}
			},

			// setPlate: function(plate){
			// 	// this.plate = plate
			// },
			//
			// get_well: function () {
			// 	// return this.plate != null ? this.plate.get_well(this.row, this.col) : null
			// },

			// get_sample: function () {
			// 	console.debug(format(
			// 		"Plate96CellRender.get_sample() this.plate = {0}",
			// 		this.plate.name))
			//
			// 	let sample = undefined
			// 	const well = this.get_well()
			// 	if (well) {
			// 		sample = well.sample
			// 	} else {
			// 		// console.debug("Plate96CellRender.get_sample() well = null")
			// 	}
			// 	return sample
			// }
		},

		/**
		 * Похоже, что компонент рендерера создается (и уничтожается)
		 * для каждой отрисовки ячейки. При этом props компонента не
		 * устанавливаются.
		 */

		// mounted: function () {
		// 	// console.debug("Plate96CellRenderer.mounted()")
		// },
		//
		// beforeUpdate() {
		// 	console.debug("Plate96CellRenderer.beforeUpdate()")
		// },
		//
		// updated: function () {
		// 	console.debug("Plate96CellRenderer.updated()")
		// },
		//
		// destroyed: function () {
		// 	console.debug("Plate96CellRenderer.destroyed()")
		// },

	}
</script>

<style scoped>
  .well-cell {
    text-align: center;
    vertical-align: middle;
    font-size: x-small;
    width: 40px;
    height: 40px;
    overflow: hidden;
    /*position: fixed;*/
  }

</style>